module.exports = __webpack_public_path__ + "static/media/somethingWentWrong.5334e29b.svg";